export const HierarchicalListRightContentName = 'hierarchicalListContentComponent';
